import { Alert, Chip } from '@zarya/ui';
import { t, tn } from '@app/i18n';
import type { ApprovalDetail } from './ApprovalsModel';
import s from './Approvals.module.css';

/**
 * O que a identidade **herda** ao ser aprovada — guarda de visibilidade nº 2 da
 * P6.2 (`docs/perguntas-pos-poc.md`).
 *
 * POR QUE ISTO FICA COLADO NO DIFF
 *
 *   Quem aprova faz uma pergunta só: «o que este agente passa a poder?». A
 *   resposta tem duas metades, e só uma estava na tela. O diff conta o que a
 *   release **pede**; esta lista conta o que vem junto de graça — as políticas
 *   ativas marcadas «todas as identidades», que passam a cobri-lo no instante da
 *   aprovação, sem ninguém as editar e sem aparecer em diff nenhum.
 *
 *   A decisão da P6.2 assumiu esse risco de propósito («uma política todas +
 *   atributo dá a ação a todo agente do tenant, INCLUSIVE OS FUTUROS») e mandou
 *   cercá-lo aqui: herança nunca acontece em silêncio.
 *
 * Lista vazia não desenha nada: «nada é herdado» é o caso comum, e um bloco
 * vazio permanente ensinaria a ignorá-lo justamente no dia em que ele encher.
 *
 * Só capabilities: a regra não concede A2A (DEF-32); o campo `a2a` da política
 * saiu do contrato em 08/09.
 */
export function InheritedPolicies({ detalhe }: { detalhe: ApprovalDetail }) {
  const herdadas = detalhe.inherited_policies ?? [];
  if (herdadas.length === 0) return null;

  return (
    <section className={s.secao}>
      <h3 className={s.secaoTitulo}>{t('approvals.inherited.title')}</h3>
      <Alert
        tone="warning"
        title={tn('approvals.inherited.alert', herdadas.length)}
      >
        <p>{t('approvals.inherited.body')}</p>
        <ul className={s.herdadas}>
          {herdadas.map((politica) => (
            <li key={politica.policy_id}>
              <strong>{politica.name}</strong>
              {politica.capabilities.length ? (
                <span className={s.chips}>
                  {politica.capabilities.map((capability) => (
                    <Chip key={capability}>{capability}</Chip>
                  ))}
                </span>
              ) : (
                <span>{t('approvals.inherited.noCapabilities')}</span>
              )}
            </li>
          ))}
        </ul>
      </Alert>
    </section>
  );
}
